import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Customer pages
import CustomerDashboard from "../pages/customer/Dashboard";
import CustomerVessels from "../pages/customer/Vessels";
import CustomerJobs from "../pages/customer/Jobs";
import CustomerMembership from "../pages/customer/Membership";
import CustomerBilling from "../pages/customer/Billing";
import CustomerSupport from "../pages/customer/Support";

function CustomerLayout({ user, onLogout }) {
  const location = useLocation();
  const navigate = useNavigate();

  // Get current page from URL path
  const getCurrentPage = () => {
    const path = location.pathname.replace("/portal/", "").replace("/portal", "");
    return path || "dashboard";
  };

  const currentPage = getCurrentPage();

  const setCurrentPage = (page) => {
    navigate(`/portal/${page}`);
  };
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("chariot-dark-mode");
    return saved === "true";
  });

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      darkMode ? "dark" : "light"
    );
    localStorage.setItem("chariot-dark-mode", darkMode);
  }, [darkMode]);

  return (
    <div className="app-container customer-portal">
      {/* CUSTOMER SIDEBAR */}
      <aside
        className={`sidebar customer-sidebar ${
          sidebarOpen ? "open" : "closed"
        }`}
      >
        <div className="sidebar-header">
          <img
            src={
              sidebarOpen
                ? "/images/Branding/Horizontal Logo/Chariot_HorizontalLogo_P1_FullColor_011226.png"
                : "/images/Branding/Mascot/Chariot_Mascot_P1_FullColor_011326.png"
            }
            alt="Chariot"
            className="logo-img"
          />
        </div>

        <nav className="sidebar-nav">
          <button
            className="menu-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            title={sidebarOpen ? "Collapse Menu" : "Expand Menu"}
          >
            <span className="icon">{sidebarOpen ? "«" : "»"}</span>
            <span className="label">{sidebarOpen ? "Collapse" : "Expand"}</span>
          </button>

          <button
            className={`nav-item ${
              currentPage === "dashboard" ? "active" : ""
            }`}
            onClick={() => setCurrentPage("dashboard")}
            title="Dashboard"
          >
            <span className="icon" data-icon="dashboard">
              <img
                src="/images/Icons/Gray Icons/Dashboard_Icon_Gray.png"
                alt=""
                className="icon-gray"
              />
              <img
                src="/images/Icons/Duotone Icons/Dashboard_Icon_Duotone.png"
                alt=""
                className="icon-duotone"
              />
            </span>
            <span className="label">Dashboard</span>
          </button>

          <button
            className={`nav-item ${currentPage === "vessels" ? "active" : ""}`}
            onClick={() => setCurrentPage("vessels")}
            title="My Vessels"
          >
            <span className="icon" data-icon="vessels">
              <img
                src="/images/Icons/Gray Icons/Inventory_Icon_Gray.png"
                alt=""
                className="icon-gray"
              />
              <img
                src="/images/Icons/Duotone Icons/Inventory_Icon_Duotone.png"
                alt=""
                className="icon-duotone"
              />
            </span>
            <span className="label">My Vessels</span>
          </button>

          <button
            className={`nav-item ${currentPage === "jobs" ? "active" : ""}`}
            onClick={() => setCurrentPage("jobs")}
            title="Service Jobs"
          >
            <span className="icon" data-icon="jobs">
              <img
                src="/images/Icons/Gray Icons/OrderChecklist_Icon_Gray.png"
                alt=""
                className="icon-gray"
              />
              <img
                src="/images/Icons/Duotone Icons/OrderChecklist_Icon_Duotone.png"
                alt=""
                className="icon-duotone"
              />
            </span>
            <span className="label">Service Jobs</span>
          </button>

          <button
            className={`nav-item ${
              currentPage === "membership" ? "active" : ""
            }`}
            onClick={() => setCurrentPage("membership")}
            title="Membership"
          >
            <span className="icon" data-icon="membership">
              <img
                src="/images/Icons/Gray Icons/Portal_Icon_Gray.png"
                alt=""
                className="icon-gray"
              />
              <img
                src="/images/Icons/Duotone Icons/Portal_Icon_Duotone.png"
                alt=""
                className="icon-duotone"
              />
            </span>
            <span className="label">Membership</span>
          </button>

          <button
            className={`nav-item ${currentPage === "billing" ? "active" : ""}`}
            onClick={() => setCurrentPage("billing")}
            title="Billing"
          >
            <span className="icon" data-icon="billing">
              <img
                src="/images/Icons/Gray Icons/PaymentsAndTransactions_Icon_Gray.png"
                alt=""
                className="icon-gray"
              />
              <img
                src="/images/Icons/Duotone Icons/PaymentsAndTransactions_Icon_Duotone.png"
                alt=""
                className="icon-duotone"
              />
            </span>
            <span className="label">Billing</span>
          </button>

          <button
            className={`nav-item ${currentPage === "support" ? "active" : ""}`}
            onClick={() => setCurrentPage("support")}
            title="Support"
          >
            <span className="icon" data-icon="support">
              <img
                src="/images/Icons/Gray Icons/Messages_Icon_Gray.png"
                alt=""
                className="icon-gray"
              />
              <img
                src="/images/Icons/Duotone Icons/Messages_Icon_Duotone.png"
                alt=""
                className="icon-duotone"
              />
            </span>
            <span className="label">Support</span>
          </button>
        </nav>

        <div className="sidebar-footer">
          <button
            className="theme-toggle"
            onClick={() => setDarkMode(!darkMode)}
            title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
          >
            <span className="icon">{darkMode ? "☀️" : "🌙"}</span>
            <span className="label">{darkMode ? "Light Mode" : "Dark Mode"}</span>
          </button>

          <button className="nav-item settings" title="Settings">
            <span className="icon" data-icon="settings">
              <img
                src="/images/Icons/Gray Icons/Settings_Icon_Gray.png"
                alt=""
                className="icon-gray"
              />
              <img
                src="/images/Icons/Duotone Icons/Settings_Icon_Duotone.png"
                alt=""
                className="icon-duotone"
              />
            </span>
            <span className="label">Settings</span>
          </button>

          <button className="nav-item logout" title="Logout" onClick={onLogout}>
            <span className="icon" data-icon="logout">
              <img
                src="/images/Icons/Gray Icons/Activity_Icon_Gray.png"
                alt=""
                className="icon-gray"
              />
              <img
                src="/images/Icons/Duotone Icons/Activity_Icon_Duotone.png"
                alt=""
                className="icon-duotone"
              />
            </span>
            <span className="label">Logout</span>
          </button>
        </div>
      </aside>

      {/* MAIN CONTENT */}
      <div className="main-wrapper">
        {/* TOP BAR */}
        <header className="top-bar customer-top-bar">
          <div className="top-bar-left">
            <h2 className="portal-title">Poseidon Marine Customer Portal</h2>
          </div>

          <div className="top-bar-right">
            <button className="icon-button" title="Notifications">
              🔔
            </button>
            <div className="user-menu">
              <span className="user-greeting">
                Welcome, {user?.first_name || "Guest"}
              </span>
              <span className="avatar">
                {user?.first_name?.[0]}
                {user?.last_name?.[0]}
              </span>
            </div>
          </div>
        </header>

        {/* PAGE CONTENT */}
        <main className="page-content customer-content">
          {currentPage === "dashboard" && <CustomerDashboard user={user} />}

          {currentPage === "vessels" && <CustomerVessels />}

          {currentPage === "jobs" && <CustomerJobs />}

          {currentPage === "membership" && <CustomerMembership />}

          {currentPage === "billing" && <CustomerBilling />}

          {currentPage === "support" && <CustomerSupport />}
        </main>
      </div>
    </div>
  );
}

export default CustomerLayout;
